import Week from "../Components/Week";
import styles from "../styles/Week.module.css";
import TopBar from "../Components/TopBar";
import ApplyForm from "../Components/ApplyForm";
import Location from "../Components/Location";
import FAQs from "../Components/FAQs";
import { useState } from "react";
export default function Machine_Learning() {
      const [openIndex, setOpenIndex] = useState(null);
    
      const toggleFAQ = (index) => {
        setOpenIndex(openIndex === index ? null : index);
      };
    
      const faqs = [
        {
          question: "What is AI & Machine Learning, and why should I learn it?",
          answer:
            <>  
AI (Artificial Intelligence) is the simulation of human intelligence in machines, while Machine
Learning (ML) is a subset of AI that enables computers to learn from data and make decisions.
Learning AI & ML opens doors to careers in <span className="ans">data science, automation, robotics, AI-driven
applications,</span> and <span className="ans">Web 3.0</span> technologies.

</>

        },
        {
            question: "Do I need a programming background to take this course?",
            answer: (
              <>
  Basic programming knowledge is helpful but not mandatory. We start from <span className="ans">Python
  fundamentals</span> and gradually move into AI & ML concepts. Even if you're a beginner, our
structured approach will help you grasp everything from scratch.

              </>
            ),
          },
        {
          question: "What programming languages and tools will I learn?",
          answer: <> You'll primarily learn <span className="ans">Python</span>, along with libraries like:
          <p className="faq-answer fheading ms-2">🔹 <span className="ans"></span>NumPy, Pandas, Matplotlib (Data Handling & Visualization)</p>
          <p className="faq-answer fheading ms-2">🔹 <span className="ans"></span> Scikit-learn (Machine Learning)</p>
          <p className="faq-answer fheading ms-2">🔹 <span className="ans"></span>TensorFlow & Keras (Deep Learning)</p>
          <p className="faq-answer fheading ms-2">🔹 <span className="ans"></span> Flask & Streamlit (AI Model Deployment)
          </p>
        
</>,
        },
     
    
        {
          question: "Is AI & ML only for software developers?",
          answer:
           <>
      No! AI & ML are used in multiple fields, including <span className="ans">finance, healthcare, marketing, robotics,
      automation, cybersecurity,</span> and <span className="ans">Web 3.0</span>. Anyone with a passion for technology can learn and
benefit from it.

           </>
        },
        {
          question: "Will this course cover Deep Learning and Neural Networks?",
          answer:
            <>Yes! Our <span className="ans">6-months course</span> dives deep into Neural Networks, CNNs, RNNs, LSTMs,
Transformers, and even AI-powered speech recognition using <span className="ans">Whisper AI</span>.</>,
        },
        {
          question: "What is Whisper AI, and why is it included in the syllabus?",
          answer:
            <>Whisper AI is <span className="ans">OpenAI's state-of-the-art speech recognition system</span>. It can transcribe,
            translate, and understand human speech with high accuracy. We include it because
            <span className="ans">AI-powered voice applications</span> are becoming the future of human-computer interaction</>,
        },
        {
          question: "What career opportunities will this course open for me?",
          answer:
           <>
      After completing the course, you can apply for roles such as: 
        <p className="faq-answer fheading ms-2">🔹  Machine Learning Engineer</p>
        <p className="faq-answer fheading ms-2">🔹 Data Scientist</p>
        <p className="faq-answer fheading ms-2">🔹 AI Developer</p>
        <p className="faq-answer fheading ms-2">🔹  NLP Engineer</p>
        <p className="faq-answer fheading ms-2">🔹 Deep Learning Engineer</p>
        <p className="faq-answer fheading ms-2">🔹 AI Consultant
        </p>
           </>
        },
        {
          question: "Will I work on real-world AI projects?",
          answer:
           <>
 Yes! We provide <span className="ans">hands-on projects </span>where you'll build AI models, work on NLP tasks, develop
chatbots, and even deploy AI applications in the cloud.

           </>
        },
        {
          question: "How is CoderMonk different from other AI & ML training institutes?",
          answer:
           <>
       
       Unlike typical training institutes, <span className="ans">we are the only ones in Jalandhar</span> working on:
<p className="faq-answer fheading ms-2"> 🔹 Custom AI Models  </p>
<p className="faq-answer fheading ms-2">🔹 Integration of ChatGPT & Whisper AI</p> 
<p className="faq-answer fheading ms-2"> 🔹 Web 3.0 AI Innovations </p>
<p className="faq-answer fheading ms-2">🔹Industry-Aligned, Practical Learning </p> 
           </>
        },
        {
            question: "Do you provide placement assistance?",
            answer:
             <>
   Yes! We help students with <span className="ans">resume building, interview preparation, and connecting with
   hiring partners </span>to ensure they get the best job opportunities in AI & ML.
  
             </>
          },
        {
            question: "Where is CoderMonk located, and how can I contact you?",
            answer:
             <>
         <p className="faq-answer fheading ms-2">📍  <span className="ans">Visit us at:</span> 2nd Floor DigitalMonk, Near Dominos, Doaba Chownk, Jalandhar, Punjab</p>
         <p className="faq-answer fheading ms-2">📞  <span className="ans">Call/WhatsApp:</span> +916284636956</p>
         <p className="faq-answer fheading ms-2">📅  <span className="ans">Next batch starts soon – Limited seats available!</span></p>
         <p className="faq-answer fheading ms-2">🚀  <span className="ans">Transform your career with React Native at CoderMonk</span></p>
             </>
          },
      ];
    
  const syllabusData = [
    {
      description: [
        {
          text: "Month 1: Python & Data Science Fundamentals",
          subDescription: [
            " Advanced Python for AI (OOP, Functional Programming)",
            "  Data Science Libraries (NumPy, Pandas, Scikit-learn)",
            " Data Visualization (Matplotlib, Seaborn, Plotly)",
            " SQL & NoSQL Databases for ML",
           
          ],
        },
        {
          text: "Month 2: Machine Learning Essentials",
          subDescription: [
            "Supervised Learning: Regression & Classification",
            "Unsupervised Learning: Clustering & Anomaly Detection",
            "Hyperparameter Tuning & Model Optimization",
            "Time Series Forecasting",
          
           
          ],
        },
        {
          text: "Month 3: Deep Learning & Neural Networks",
          subDescription: [
            "Neural Networks with TensorFlow & Keras",
            "Convolutional Neural Networks (CNN) for Image Processing",
            "Recurrent Neural Networks (RNN) for Time Series & NLP",
            "Generative Adversarial Networks (GANs)",
          
           
          ],
        },
        {
          text: " Month 4: AI for Web 3.0 & Cloud Deployment",
          subDescription: [
            " AI & Web 3.0: AI-driven Blockchain Applications",
            " Deploying AI Models on AWS, Google Cloud, & Azure",
            " API Development & AI Chatbots",
          
          ],
        }, 
        {
            text: "  Month 5: Natural Language Processing (NLP) & Whisper AI",
            subDescription: [
              " Text Processing & Sentiment Analysis",
              "  AI Speech Recognition using OpenAI Whisper AI",
              " Transformers & Large Language Models (LLMs)",
            
            ],
          }, 
          {
            text: "  Month 6: Advanced AI & Industry-Level Capstone Project",
            subDescription: [
              " Reinforcement Learning & AI in Robotics",
              " Building Custom LLMs & AI Fine-Tuning",
              " Industry-Level AI Project (Custom AI Application)",
            " AI Ethics & Future Trends"
            ],
          }, 
      ],
    },
  ];
  
  const syllabusData_one = [
    {
      description: [
        {
          text: "Week 1: Introduction to AI & ML",
          subDescription: [
            " Understanding AI, ML, and Deep Learning",
            "  Applications of AI & ML",
            " Setting up Python Environment (Jupyter, Colab)",
            "Python Basics for AI & ML (NumPy, Pandas, Matplotlib)",
          
          ],
        },
        {
          text: "Week 2: Data Preprocessing & Feature Engineering",
          subDescription: [
            "Data Cleaning & Handling Missing Values",
            "Feature Scaling & Selection",
            "Exploratory Data Analysis (EDA)",
          
          ],
        },
        {
          text: "Week 3: Supervised Learning",
          subDescription: [
            "Linear Regression & Logistic Regression",
            "Decision Trees & Random Forest",
            "Support Vector Machines (SVM)",
            " Model Evaluation Metrics",
          
          ],
        },
        {
          text: "Week 4: Unsupervised Learning & Neural Networks",
          subDescription: [
            " Clustering (K-Means, DBSCAN)",
            " Dimensionality Reduction (PCA, t-SNE)",
            "  Introduction to Neural Networks & TensorFlow Basics",
          
          ],
        },
        {
            text: "Week 5: Deep Learning & Real-World Projects",
            subDescription: [
              " Convolutional Neural Networks (CNN) for Image Processing",
              " Recurrent Neural Networks (RNN) & LSTMs",
              "  Deploying AI Models with Flask & Streamlit",
            "AI-Powered Capstone Project"
            ],
          },
      ],
    },
  ];
  return (
    <>
      <style jsx>{`
     
        .syllabus_heading {
          text-align: center;
          font-size: 3rem;
          margin-bottom: 2rem;
          color: #004085;
        }
  
        .card_container {
          display: grid;
          grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
          gap: 2rem;
          padding: 1rem;
        }
  
        .card {
          background-color: #fff;
          border-radius: 8px;
          box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
          padding: 1.5rem;
          transition: transform 0.3s ease, box-shadow 0.3s ease;
        }
  
        .card:hover {
          transform: translateY(-10px);
          box-shadow: 0 8px 16px rgba(0, 0, 0, 0.2);
        }
  
        .card_title {
          font-size: 1.1rem;
          color: #006a4f;
          margin-bottom: 1rem;
        }
  
        .card_sublist {
          list-style-type: circle;
          padding-left: 20px;
          margin: 0;
          color: #001f3f;
          font-weight: 600;
        }
  
        .card_subitem {
          margin-bottom: 0.5rem;
        }
  
        @media (max-width: 768px) {
          .card_container {
            grid-template-columns: 1fr;
          }
        }
  
        @media (max-width: 300px) {
          .p {
            font-size: 1.1rem;
            white-space: nowrap;
          }
        }
      `}</style>
      <div className="container-xxl py-5">
  <div className="container-fluid  d-flex align-items-center justify-content-center">
    <div className="row g-5">
      <div
        className="col-lg-6 wow fadeInUp"
        data-wow-delay="0.1s"
        style={{ minHeight: 400 }}
      >
        <div className="position-relative h-100">
          <img
            className="img-fluid position-absolute w-100 h-100"
            src="https://cdn.pixabay.com/photo/2020/06/12/14/06/machine-learning-5290464_640.jpg"
            alt=""
            style={{ objectFit: "cover" }}
          />
        </div>
      </div>
      <div className="col-lg-6 wow fadeInUp" data-wow-delay="0.3s">
      <div className='d-flex flex-start align-items-center justify-content-start mt-2'>
          
                    <h6 className="sub_heading text-start">Syllabus</h6>
                    <img 
                    className='ps-3'
                    src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwCAYAAABXAvmHAAAACXBIWXMAAAsTAAALEwEAmpwYAAACLklEQVR4nO2XT2sTQRTAn/SgYO3uzG6Tk1RRqwgW/x68SE+56ofQq36EaJP31lovfo2AINLsmy3FXPXspSfBgijGahGE3iIvkmQqDenuBsvg/OBd3mF23uzb2d8D8Hg8Ho/H85+jGR8pQy9jbl4H1wiyxlltqNcPph/OFVHN1k4qxk+jIvBbmOISuIRqP70iGx8WYeirTvEyuESQNa9qpp1BEYrpS2TwUqlFK5tYVUzvNNP7uE2Lk/I6rc8pgx1t8HvB2LPegrTTx2q2VilcgDL4YHQi+HhSPjJ4b98GphCKk/vlbgimbW2wa98O4/KzKc4rQ1tTK4BpJ+DkDJSi1zsGrdbMofNSYKceBuuJyhPRRvOmHIjVPrtRSrfABZRpnNZMH4ZtY+hXmCV3wAUWOvUTdtvJ5iNOlsEV4o2VC6O+xz2dUQ1cQxt6phjfOrl5T17k3hf11UwPwTXiLLkhyjv46ML1xgK4Qpjikm2MosCiwuACcZsWlcHP9uARpMk1cIF5Q+f/Gjh25bcPLlDZxOofabMlS5S3mC4rpjfRq9VTg/UjXrkoSi7/AHnWpHxubG2eVkSc3B2uz/TkIG0el8+NqKw9JZV2e0Nbs6+fx/tuNYNdGVxsbR6XL4QorfS91UJd+Qby6rIo9oEPaLVm+mp+2HwRFNNtZfCndQttlx80/jERJ8uiunY7QPriOLiEzqhmD95zaeMcuIbOqNZXX0OrR70Xj8fj8Xg8cMT8BtFVe5J3SM2jAAAAAElFTkSuQmCC" alt="sorting-arrows-horizontal"/>
                  </div>
        <h1 className="Heading">AI & Machine Learning Using Python</h1>
       
        <h6 style={{color:"#c63b36"}} className="mt-3">Learn AI & Machine-Learing Like a Pro!</h6>
        <p className="mb-4" style={{color:"#001f3f"}}>
        We transform your innovative ideas into intelligent machine learning solutions, delivering a seamless and impactful user experience.
        </p>
       
     
        <a className="btn  py-3 px-5 mt-2 text-white" href="#form" style={{backgroundColor:"yellowgreen"}}>
        Join Now
        </a>
      </div>
    </div>
  </div>
</div>

<div className="container-xxl mt-5">
  <div className="container">
    <div className="text-center wow fadeInUp" data-wow-delay="0.1s">
    <div className='d-flex flex-row align-items-center justify-content-center mb-5'>
            <img 
                    className='pe-3'
                    src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwCAYAAABXAvmHAAAACXBIWXMAAAsTAAALEwEAmpwYAAACLklEQVR4nO2XT2sTQRTAn/SgYO3uzG6Tk1RRqwgW/x68SE+56ofQq36EaJP31lovfo2AINLsmy3FXPXspSfBgijGahGE3iIvkmQqDenuBsvg/OBd3mF23uzb2d8D8Hg8Ho/H85+jGR8pQy9jbl4H1wiyxlltqNcPph/OFVHN1k4qxk+jIvBbmOISuIRqP70iGx8WYeirTvEyuESQNa9qpp1BEYrpS2TwUqlFK5tYVUzvNNP7uE2Lk/I6rc8pgx1t8HvB2LPegrTTx2q2VilcgDL4YHQi+HhSPjJ4b98GphCKk/vlbgimbW2wa98O4/KzKc4rQ1tTK4BpJ+DkDJSi1zsGrdbMofNSYKceBuuJyhPRRvOmHIjVPrtRSrfABZRpnNZMH4ZtY+hXmCV3wAUWOvUTdtvJ5iNOlsEV4o2VC6O+xz2dUQ1cQxt6phjfOrl5T17k3hf11UwPwTXiLLkhyjv46ML1xgK4Qpjikm2MosCiwuACcZsWlcHP9uARpMk1cIF5Q+f/Gjh25bcPLlDZxOofabMlS5S3mC4rpjfRq9VTg/UjXrkoSi7/AHnWpHxubG2eVkSc3B2uz/TkIG0el8+NqKw9JZV2e0Nbs6+fx/tuNYNdGVxsbR6XL4QorfS91UJd+Qby6rIo9oEPaLVm+mp+2HwRFNNtZfCndQttlx80/jERJ8uiunY7QPriOLiEzqhmD95zaeMcuIbOqNZXX0OrR70Xj8fj8Xg8cMT8BtFVe5J3SM2jAAAAAElFTkSuQmCC" alt="sorting-arrows-horizontal"/>
                    <h6 className="sub_heading p" style={{whiteSpace:"nowrap"}}>6-Months</h6>
                    <img 
                    className='ps-3'
                    src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwCAYAAABXAvmHAAAACXBIWXMAAAsTAAALEwEAmpwYAAACLklEQVR4nO2XT2sTQRTAn/SgYO3uzG6Tk1RRqwgW/x68SE+56ofQq36EaJP31lovfo2AINLsmy3FXPXspSfBgijGahGE3iIvkmQqDenuBsvg/OBd3mF23uzb2d8D8Hg8Ho/H85+jGR8pQy9jbl4H1wiyxlltqNcPph/OFVHN1k4qxk+jIvBbmOISuIRqP70iGx8WYeirTvEyuESQNa9qpp1BEYrpS2TwUqlFK5tYVUzvNNP7uE2Lk/I6rc8pgx1t8HvB2LPegrTTx2q2VilcgDL4YHQi+HhSPjJ4b98GphCKk/vlbgimbW2wa98O4/KzKc4rQ1tTK4BpJ+DkDJSi1zsGrdbMofNSYKceBuuJyhPRRvOmHIjVPrtRSrfABZRpnNZMH4ZtY+hXmCV3wAUWOvUTdtvJ5iNOlsEV4o2VC6O+xz2dUQ1cQxt6phjfOrl5T17k3hf11UwPwTXiLLkhyjv46ML1xgK4Qpjikm2MosCiwuACcZsWlcHP9uARpMk1cIF5Q+f/Gjh25bcPLlDZxOofabMlS5S3mC4rpjfRq9VTg/UjXrkoSi7/AHnWpHxubG2eVkSc3B2uz/TkIG0el8+NqKw9JZV2e0Nbs6+fx/tuNYNdGVxsbR6XL4QorfS91UJd+Qby6rIo9oEPaLVm+mp+2HwRFNNtZfCndQttlx80/jERJ8uiunY7QPriOLiEzqhmD95zaeMcuIbOqNZXX0OrR70Xj8fj8Xg8cMT8BtFVe5J3SM2jAAAAAElFTkSuQmCC" alt="sorting-arrows-horizontal"/>
                  </div>
     
   
    </div>
    </div>
    </div>
      <div className="card_container">
        {syllabusData.map((module, index) =>
          module.description.map((item, itemIndex) => (
            <div key={itemIndex} className="card bgimg">
              <h3 className="card_title">{item.text}</h3>
              <ul className="card_sublist">
                {item.subDescription.map((subItem, subIndex) => (
                  <li key={subIndex} className="card_subitem">
                    {subItem}
                  </li>
                ))}
              </ul>
            </div>
          ))
        )}
      </div>
      <div className="container-xxl mt-5">
  <div className="container">
    <div className="text-center wow fadeInUp" data-wow-delay="0.1s">
    <div className='d-flex flex-row align-items-center justify-content-center mb-5'>
            <img 
                    className='pe-3'
                    src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwCAYAAABXAvmHAAAACXBIWXMAAAsTAAALEwEAmpwYAAACLklEQVR4nO2XT2sTQRTAn/SgYO3uzG6Tk1RRqwgW/x68SE+56ofQq36EaJP31lovfo2AINLsmy3FXPXspSfBgijGahGE3iIvkmQqDenuBsvg/OBd3mF23uzb2d8D8Hg8Ho/H85+jGR8pQy9jbl4H1wiyxlltqNcPph/OFVHN1k4qxk+jIvBbmOISuIRqP70iGx8WYeirTvEyuESQNa9qpp1BEYrpS2TwUqlFK5tYVUzvNNP7uE2Lk/I6rc8pgx1t8HvB2LPegrTTx2q2VilcgDL4YHQi+HhSPjJ4b98GphCKk/vlbgimbW2wa98O4/KzKc4rQ1tTK4BpJ+DkDJSi1zsGrdbMofNSYKceBuuJyhPRRvOmHIjVPrtRSrfABZRpnNZMH4ZtY+hXmCV3wAUWOvUTdtvJ5iNOlsEV4o2VC6O+xz2dUQ1cQxt6phjfOrl5T17k3hf11UwPwTXiLLkhyjv46ML1xgK4Qpjikm2MosCiwuACcZsWlcHP9uARpMk1cIF5Q+f/Gjh25bcPLlDZxOofabMlS5S3mC4rpjfRq9VTg/UjXrkoSi7/AHnWpHxubG2eVkSc3B2uz/TkIG0el8+NqKw9JZV2e0Nbs6+fx/tuNYNdGVxsbR6XL4QorfS91UJd+Qby6rIo9oEPaLVm+mp+2HwRFNNtZfCndQttlx80/jERJ8uiunY7QPriOLiEzqhmD95zaeMcuIbOqNZXX0OrR70Xj8fj8Xg8cMT8BtFVe5J3SM2jAAAAAElFTkSuQmCC" alt="sorting-arrows-horizontal"/>
                    <h6 className="sub_heading p">45-Days</h6>
                    <img 
                    className='ps-3'
                    src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwCAYAAABXAvmHAAAACXBIWXMAAAsTAAALEwEAmpwYAAACLklEQVR4nO2XT2sTQRTAn/SgYO3uzG6Tk1RRqwgW/x68SE+56ofQq36EaJP31lovfo2AINLsmy3FXPXspSfBgijGahGE3iIvkmQqDenuBsvg/OBd3mF23uzb2d8D8Hg8Ho/H85+jGR8pQy9jbl4H1wiyxlltqNcPph/OFVHN1k4qxk+jIvBbmOISuIRqP70iGx8WYeirTvEyuESQNa9qpp1BEYrpS2TwUqlFK5tYVUzvNNP7uE2Lk/I6rc8pgx1t8HvB2LPegrTTx2q2VilcgDL4YHQi+HhSPjJ4b98GphCKk/vlbgimbW2wa98O4/KzKc4rQ1tTK4BpJ+DkDJSi1zsGrdbMofNSYKceBuuJyhPRRvOmHIjVPrtRSrfABZRpnNZMH4ZtY+hXmCV3wAUWOvUTdtvJ5iNOlsEV4o2VC6O+xz2dUQ1cQxt6phjfOrl5T17k3hf11UwPwTXiLLkhyjv46ML1xgK4Qpjikm2MosCiwuACcZsWlcHP9uARpMk1cIF5Q+f/Gjh25bcPLlDZxOofabMlS5S3mC4rpjfRq9VTg/UjXrkoSi7/AHnWpHxubG2eVkSc3B2uz/TkIG0el8+NqKw9JZV2e0Nbs6+fx/tuNYNdGVxsbR6XL4QorfS91UJd+Qby6rIo9oEPaLVm+mp+2HwRFNNtZfCndQttlx80/jERJ8uiunY7QPriOLiEzqhmD95zaeMcuIbOqNZXX0OrR70Xj8fj8Xg8cMT8BtFVe5J3SM2jAAAAAElFTkSuQmCC" alt="sorting-arrows-horizontal"/>
                  </div>
     
   
    </div>
    </div>
    </div>

    <div className="card_container">
        {syllabusData_one.map((module, index) =>
          module.description.map((item, itemIndex) => (
            <div key={itemIndex} className="card bgimg">
              <h6 className="card_title">{item.text}</h6>
              <ul className="card_sublist">
                {item.subDescription.map((subItem, subIndex) => (
                  <li key={subIndex} className="card_subitem">
                    {subItem}
                  </li>
                ))}
              </ul>
            </div>
          ))
        )}
      </div>
      <div className="container-xxl mt-5">
  <div className="container">
    <div className="text-center wow fadeInUp" data-wow-delay="0.1s">
    <div className='d-flex flex-row align-items-center justify-content-center mb-5'>
            <img 
                    className='pe-3'
                    src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwCAYAAABXAvmHAAAACXBIWXMAAAsTAAALEwEAmpwYAAACLklEQVR4nO2XT2sTQRTAn/SgYO3uzG6Tk1RRqwgW/x68SE+56ofQq36EaJP31lovfo2AINLsmy3FXPXspSfBgijGahGE3iIvkmQqDenuBsvg/OBd3mF23uzb2d8D8Hg8Ho/H85+jGR8pQy9jbl4H1wiyxlltqNcPph/OFVHN1k4qxk+jIvBbmOISuIRqP70iGx8WYeirTvEyuESQNa9qpp1BEYrpS2TwUqlFK5tYVUzvNNP7uE2Lk/I6rc8pgx1t8HvB2LPegrTTx2q2VilcgDL4YHQi+HhSPjJ4b98GphCKk/vlbgimbW2wa98O4/KzKc4rQ1tTK4BpJ+DkDJSi1zsGrdbMofNSYKceBuuJyhPRRvOmHIjVPrtRSrfABZRpnNZMH4ZtY+hXmCV3wAUWOvUTdtvJ5iNOlsEV4o2VC6O+xz2dUQ1cQxt6phjfOrl5T17k3hf11UwPwTXiLLkhyjv46ML1xgK4Qpjikm2MosCiwuACcZsWlcHP9uARpMk1cIF5Q+f/Gjh25bcPLlDZxOofabMlS5S3mC4rpjfRq9VTg/UjXrkoSi7/AHnWpHxubG2eVkSc3B2uz/TkIG0el8+NqKw9JZV2e0Nbs6+fx/tuNYNdGVxsbR6XL4QorfS91UJd+Qby6rIo9oEPaLVm+mp+2HwRFNNtZfCndQttlx80/jERJ8uiunY7QPriOLiEzqhmD95zaeMcuIbOqNZXX0OrR70Xj8fj8Xg8cMT8BtFVe5J3SM2jAAAAAElFTkSuQmCC" alt="sorting-arrows-horizontal"/>
                    <h6 className="sub_heading p">FAQs</h6>
                    <img 
                    className='ps-3'
                    src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwCAYAAABXAvmHAAAACXBIWXMAAAsTAAALEwEAmpwYAAACLklEQVR4nO2XT2sTQRTAn/SgYO3uzG6Tk1RRqwgW/x68SE+56ofQq36EaJP31lovfo2AINLsmy3FXPXspSfBgijGahGE3iIvkmQqDenuBsvg/OBd3mF23uzb2d8D8Hg8Ho/H85+jGR8pQy9jbl4H1wiyxlltqNcPph/OFVHN1k4qxk+jIvBbmOISuIRqP70iGx8WYeirTvEyuESQNa9qpp1BEYrpS2TwUqlFK5tYVUzvNNP7uE2Lk/I6rc8pgx1t8HvB2LPegrTTx2q2VilcgDL4YHQi+HhSPjJ4b98GphCKk/vlbgimbW2wa98O4/KzKc4rQ1tTK4BpJ+DkDJSi1zsGrdbMofNSYKceBuuJyhPRRvOmHIjVPrtRSrfABZRpnNZMH4ZtY+hXmCV3wAUWOvUTdtvJ5iNOlsEV4o2VC6O+xz2dUQ1cQxt6phjfOrl5T17k3hf11UwPwTXiLLkhyjv46ML1xgK4Qpjikm2MosCiwuACcZsWlcHP9uARpMk1cIF5Q+f/Gjh25bcPLlDZxOofabMlS5S3mC4rpjfRq9VTg/UjXrkoSi7/AHnWpHxubG2eVkSc3B2uz/TkIG0el8+NqKw9JZV2e0Nbs6+fx/tuNYNdGVxsbR6XL4QorfS91UJd+Qby6rIo9oEPaLVm+mp+2HwRFNNtZfCndQttlx80/jERJ8uiunY7QPriOLiEzqhmD95zaeMcuIbOqNZXX0OrR70Xj8fj8Xg8cMT8BtFVe5J3SM2jAAAAAElFTkSuQmCC" alt="sorting-arrows-horizontal"/>
                  </div>
     
   
    </div>
    </div>
    </div>



    <div className="faq-container mb-5">
     
     <div className="faq-list">
       {faqs.map((faq, index) => (
         <div key={index} className="faq-item">
           <div
             className="faq-header"
             onClick={() => toggleFAQ(index)}
            
           >
             <h2 className="faq-question  fheading">{faq.question}</h2>
             <span className="faq-icon">
               {openIndex === index ? "−" : "+"}
             </span>
           </div>
           {openIndex === index && (
             <p className="faq-answer fheading">{faq.answer}</p>
           )}
         </div>
       ))}
     </div>
   </div>







      <div class="container-xxl mt-5 py-3" >
        <div class="container">
         
<div className="container-xxl mt-5">
  <div className="container">
    <div className="text-center wow fadeInUp" data-wow-delay="0.1s">
    <div className='d-flex flex-row align-items-center justify-content-center mb-5'>
            <img 
                    className='pe-3'
                    src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwCAYAAABXAvmHAAAACXBIWXMAAAsTAAALEwEAmpwYAAACLklEQVR4nO2XT2sTQRTAn/SgYO3uzG6Tk1RRqwgW/x68SE+56ofQq36EaJP31lovfo2AINLsmy3FXPXspSfBgijGahGE3iIvkmQqDenuBsvg/OBd3mF23uzb2d8D8Hg8Ho/H85+jGR8pQy9jbl4H1wiyxlltqNcPph/OFVHN1k4qxk+jIvBbmOISuIRqP70iGx8WYeirTvEyuESQNa9qpp1BEYrpS2TwUqlFK5tYVUzvNNP7uE2Lk/I6rc8pgx1t8HvB2LPegrTTx2q2VilcgDL4YHQi+HhSPjJ4b98GphCKk/vlbgimbW2wa98O4/KzKc4rQ1tTK4BpJ+DkDJSi1zsGrdbMofNSYKceBuuJyhPRRvOmHIjVPrtRSrfABZRpnNZMH4ZtY+hXmCV3wAUWOvUTdtvJ5iNOlsEV4o2VC6O+xz2dUQ1cQxt6phjfOrl5T17k3hf11UwPwTXiLLkhyjv46ML1xgK4Qpjikm2MosCiwuACcZsWlcHP9uARpMk1cIF5Q+f/Gjh25bcPLlDZxOofabMlS5S3mC4rpjfRq9VTg/UjXrkoSi7/AHnWpHxubG2eVkSc3B2uz/TkIG0el8+NqKw9JZV2e0Nbs6+fx/tuNYNdGVxsbR6XL4QorfS91UJd+Qby6rIo9oEPaLVm+mp+2HwRFNNtZfCndQttlx80/jERJ8uiunY7QPriOLiEzqhmD95zaeMcuIbOqNZXX0OrR70Xj8fj8Xg8cMT8BtFVe5J3SM2jAAAAAElFTkSuQmCC" alt="sorting-arrows-horizontal"/>
                    <h6 className="sub_heading p">Contact</h6>
                    <img 
                    className='ps-3'
                    src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwCAYAAABXAvmHAAAACXBIWXMAAAsTAAALEwEAmpwYAAACLklEQVR4nO2XT2sTQRTAn/SgYO3uzG6Tk1RRqwgW/x68SE+56ofQq36EaJP31lovfo2AINLsmy3FXPXspSfBgijGahGE3iIvkmQqDenuBsvg/OBd3mF23uzb2d8D8Hg8Ho/H85+jGR8pQy9jbl4H1wiyxlltqNcPph/OFVHN1k4qxk+jIvBbmOISuIRqP70iGx8WYeirTvEyuESQNa9qpp1BEYrpS2TwUqlFK5tYVUzvNNP7uE2Lk/I6rc8pgx1t8HvB2LPegrTTx2q2VilcgDL4YHQi+HhSPjJ4b98GphCKk/vlbgimbW2wa98O4/KzKc4rQ1tTK4BpJ+DkDJSi1zsGrdbMofNSYKceBuuJyhPRRvOmHIjVPrtRSrfABZRpnNZMH4ZtY+hXmCV3wAUWOvUTdtvJ5iNOlsEV4o2VC6O+xz2dUQ1cQxt6phjfOrl5T17k3hf11UwPwTXiLLkhyjv46ML1xgK4Qpjikm2MosCiwuACcZsWlcHP9uARpMk1cIF5Q+f/Gjh25bcPLlDZxOofabMlS5S3mC4rpjfRq9VTg/UjXrkoSi7/AHnWpHxubG2eVkSc3B2uz/TkIG0el8+NqKw9JZV2e0Nbs6+fx/tuNYNdGVxsbR6XL4QorfS91UJd+Qby6rIo9oEPaLVm+mp+2HwRFNNtZfCndQttlx80/jERJ8uiunY7QPriOLiEzqhmD95zaeMcuIbOqNZXX0OrR70Xj8fj8Xg8cMT8BtFVe5J3SM2jAAAAAElFTkSuQmCC" alt="sorting-arrows-horizontal"/>
                  </div>
     
   
    </div>
    </div>
    </div>
            <div className='mt-4'>
            <ApplyForm/>
            </div>
        
        </div>
    </div>

    <div className='container mt-5 mb-5'>
        <div className='row'>
            <div className='col-12'>
            <iframe
                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3407.4728947145964!2d75.58318561066835!3d31.345927155633603!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x391a5bde4b978ac5%3A0xe6b30ccf89446f33!2sDigitalMonk!5e0!3m2!1sen!2sin!4v1737619055819!5m2!1sen!2sin"
                style={{ border: 0, width: "100%", height: "350px" }}
                allowFullScreen=""
                loading="lazy"
              ></iframe>
            </div>
        </div>
    </div>

    </>
  );
  
}
